export default __webpack_public_path__ + "static/iam_role_08-8e6e54737059ad52e9528bc5d2553f1d.png";